import angular from 'angular';

import component from './entity-manage-delete-link.component';

const EntityManageDeleteLink = angular
    .module('control-room.commons.content.components.entity-manage-delete-link', [])
    .component('crEntityManageDeleteLink', component);

export default EntityManageDeleteLink;
